module.exports = __webpack_public_path__ + "img/system14-mini.ac3a8a02.png";